import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import {
  Tab,
  Tabs,
  TabList,
  TabPanel,
} from 'react-tabs';
import { FaChevronRight, FaExclamationCircle } from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { request } from 'graphql-request';
import * as actions from '../../../actions';

import General from './General';
import Design from './Design';
import Shipping from './Shipping';
import Opening from './Opening';
import Roles from './Roles';
import Loading from '../../../components/Loading/Page';
import Footer from '../../../components/Footer';

import { Content } from './styles';
import { Wrapper, Breadcrumb } from '../../../assets/styles';

class Profile extends Component {
  state = {
    breadcrumb: 'Geral',
    store: undefined,
  }

  componentDidMount = () => {
    const query = `
      query {
        currentStorePortal(storeId: "${this.props.store.id}") {
          id
          avatarUrl
          coverUrl
          name
          cnpj
          socialReason
          phoneNumber
          email
          description
          address
          orders
          delivery
          operatingHours
        }
      }
    `;

    request(process.env.REACT_APP_GRAPHQL_ENDPOINT, query)
      .then((res) => {
        this.setState({ store: res.currentStorePortal });
      })
      .catch(console.error);
  }

  handleChangeState = (data) => {
    this.setState(prevState => ({
      store: {
        ...prevState.store,
        ...data,
      },
    }));
  }

  setBreadcrumb = (index) => {
    if (index === 0) {
      this.setState({ breadcrumb: 'Geral' });
    } else if (index === 1) {
      this.setState({ breadcrumb: 'Design' });
    } else if (index === 2) {
      this.setState({ breadcrumb: 'Pedido e entrega' });
    } else if (index === 3) {
      this.setState({ breadcrumb: 'Horário de entrega' });
    } else if (index === 4) {
      this.setState({ breadcrumb: 'Funções administrativas' });
    }
  }

  render() {
    const { breadcrumb, store } = this.state;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Minha loja - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Minha loja</h2>
            <FaChevronRight className="fas fa-chevron-right" />
            <h2 className="bold">{breadcrumb}</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          {!store && (
            <Loading />
          )}
          {store && (
            <Content>
              <Tabs className="tabs" defaultIndex={0} onSelect={index => this.setBreadcrumb(index)}>
                <div className="left">
                  <TabList>
                    <Tab>
                      <span className="required">Geral</span>
                      {store.description.length === 0 && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                    </Tab>
                    <Tab>
                      <span className="required">Design</span>
                      {(!store.avatarUrl || !store.coverUrl) && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                    </Tab>
                    <Tab>
                      <span className="required">Pedido e entrega</span>
                      {!store.delivery.distance && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                    </Tab>
                    <Tab>
                      <span className="required">Horário de entrega</span>
                      {!store.operatingHours && <FaExclamationCircle className="fa fa-exclamation-circle" />}
                    </Tab>
                    <Tab>
                      <span>Funções administrativas</span>
                    </Tab>
                  </TabList>
                </div>
                <div className="right">
                  <TabPanel>
                    <General
                      store={store}
                      handleChangeState={this.handleChangeState}
                      saveStore={this.props.saveStore}
                    />
                  </TabPanel>
                  <TabPanel>
                    <Design
                      store={store}
                      storesList={this.props.user.stores}
                      handleChangeState={this.handleChangeState}
                      saveStore={this.props.saveStore}
                      saveUser={this.props.saveUser}
                    />
                  </TabPanel>
                  <TabPanel>
                    <Shipping store={store} handleChangeState={this.handleChangeState} />
                  </TabPanel>
                  <TabPanel>
                    <Opening
                      store={store}
                      handleChangeState={this.handleChangeState}
                      saveStore={this.props.saveStore}
                    />
                  </TabPanel>
                  <TabPanel>
                    <Roles
                      user={{ userId: this.props.user.id, roleType: this.props.store.roleType }}
                      store={store}
                      handleChangeState={this.handleChangeState}
                    />
                  </TabPanel>
                </div>
              </Tabs>
            </Content>
          )}
          <Footer />
        </Wrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  store: state.store,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispathToProps)(Profile);
